/**
 * 记账凭证打印配置
 * 打印数据构建函数，将单张凭证数据转换为打印所需格式
 * 金额按 亿千百十万千百十元角分 拆分为11位数字字段（与凭证编辑器录入样式一致）
 */

import moment from 'moment'
import { getLoginName } from '@/utils/util'

export const VOUCHER_BILL_TYPE = 'VOUCHER'

// 借方金额11位数字字段 d1~d11，贷方金额 c1~c11
const DEBIT_KEYS = ['d1', 'd2', 'd3', 'd4', 'd5', 'd6', 'd7', 'd8', 'd9', 'd10', 'd11']
const CREDIT_KEYS = ['c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'c10', 'c11']

/**
 * 金额拆分为 亿千百十万千百十元角分 11位数字字段
 * 打印规则：
 * 1. 金额为0或空时所有位留空（含角分）
 * 2. 负数取绝对值按位显示，-号放到亿格（打印无颜色标识）
 * 3. 前导零显示为空
 */
function splitAmountToFields(amount, keys) {
  const num = Number(amount)
  if (!amount || !num) {
    const out = {}
    keys.forEach(k => { out[k] = '' })
    return out
  }
  const s = Math.round(Math.abs(num) * 100).toString().padStart(11, '0')
  const out = {}
  let started = false
  for (let i = 0; i < 9; i++) {
    const ch = s.charAt(i)
    if (!started && ch === '0') {
      out[keys[i]] = ''
    } else {
      started = true
      out[keys[i]] = ch
    }
  }
  out[keys[9]] = s.charAt(9)
  out[keys[10]] = s.charAt(10)
  if (num < 0) {
    out[keys[0]] = '-' + (out[keys[0]] || '')
  }
  return out
}

/**
 * 构建一行表格数据：摘要 + 科目 + 借贷双方11位数字
 */
function buildRow(summary, subject, debit, credit) {
  return Object.assign(
    { summary: summary, subject: subject },
    splitAmountToFields(debit, DEBIT_KEYS),
    splitAmountToFields(credit, CREDIT_KEYS)
  )
}

// 打印数据构建 - 将凭证数据映射为打印字段
export function buildVoucherPrintData(dataSource, queryParam, userInfo, companyInfo) {
  const v = (dataSource && dataSource[0]) || {}

  // 步骤1：映射明细行（借贷金额拆分为 亿千百十万千百十元角分 11列）
  const rows = (v.items || []).map(it => buildRow(
    it.summary || '',
    ((it.subjectCode || '') + (it.subjectName ? ' ' + it.subjectName : '')).trim(),
    it.debitAmount,
    it.creditAmount
  ))

  // 步骤2：分录不足4行用空行补齐（常规凭证票据固定4行）
  while (rows.length < 4) {
    rows.push(buildRow('', '', null, null))
  }

  // 步骤3：追加合计行到表格末尾
  rows.push(buildRow('合计', '', v.debitTotal, v.creditTotal))

  return {
    reportTitle: '记账凭证',
    reportDate: new Date().toLocaleDateString(),
    voucherNo: v.voucherNo || '',
    voucherDate: v.voucherDate ? moment(String(v.voucherDate)).format('YYYY-MM-DD') : '',
    period: v.period || '',
    status: v.status || '',
    creatorName: getLoginName(),
    totalDebit: Number(v.debitTotal) || 0,
    totalCredit: Number(v.creditTotal) || 0,
    table: rows,
    companyName: (companyInfo && companyInfo.companyName) || '',
    companyAddress: (companyInfo && companyInfo.companyAddress) || '',
    companyTel: (companyInfo && companyInfo.companyTel) || ''
  }
}
